import React  from 'react'
import useFetch from '../../Services/useFetch'
import { useHistory, useParams } from 'react-router-dom';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tabs';
import { endpoints } from '../../utils/Constants';
import ManageEntities from './ManageEntities'
import { useEffect } from 'react';
import ManageEmailTemplates from './ManageEmailTemplates';

import ManageTermsAndConditions from './ManageTermsAndConditions';
import ManageSelections from './ManageSelections';
import AirportLookupEditor from './AirportLookupEditor';
import LoadingAnimation from '../Form/LoadingAnimation';

const ManageWorkflow = () => {
    const { choice, entity, id } = useParams();
    const [entities, loading, error] = useFetch(endpoints.getAllEntities);
   
    let history = useHistory();
    const route = '/manageWorkflow'
    const tabs = [
        {
            route: 'entities', name: "Entities", control: <ManageEntities route={route + '/entities'} entity={entity} allEntities={entities} id={id} />
        },
        { route: 'selections', name: "Selections", control: <ManageSelections route={route + '/selections'} /> },
        { route: 'emails', name: "Email Templates", control: <ManageEmailTemplates route={route + '/email'} /> },
        { route: 'terms', name: "T's&C's", control: <ManageTermsAndConditions route={route + '/terms'} /> },
        { route: 'lookup', name: "Airport Lookup", control: <AirportLookupEditor route={route + '/lookup'} /> },

    ];
    const requestedTab = tabs.find(x => x.route === choice);
    const activeKey = requestedTab ? requestedTab.route : tabs[0].route;

    useEffect(() => {

       if (!requestedTab) {
            history.push(route + '/' + activeKey+'/');
        }
    }, [history, requestedTab,activeKey]);

    const setActiveTab = (tab) => {
        if (choice !== tab.route) {
            history.push(route +'/'+ tab+'/');
        }
    }
    return <React.Fragment>
        {loading ? <LoadingAnimation /> : null}
        {error?<h6>Error Loading Entities</h6>:null}
        <Tabs mountOnEnter={true} defaultActiveKey={activeKey} onSelect={setActiveTab} >
            {
                tabs.map(tab => {
                    return <Tab key={tab.route} eventKey={tab.route} title={tab.name} >
                        {choice === tab.route?tab.control:null}
                    </Tab>
                })

            }
        </Tabs>
    </React.Fragment>

}

export default ManageWorkflow;

